import type { Parchment } from 'quill/core';

const getReferenceNodeForBounds = (blot: Parchment.Blot): HTMLElement => {
  return 'getReferenceNodeForBounds' in blot &&
    typeof blot.getReferenceNodeForBounds === 'function'
    ? blot.getReferenceNodeForBounds()
    : (blot.domNode as HTMLElement);
};

export default getReferenceNodeForBounds;
